import { render, staticRenderFns } from "./menuConsumption.vue?vue&type=template&id=f19c62b8&"
import script from "./menuConsumption.vue?vue&type=script&lang=js&"
export * from "./menuConsumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports